import { render, staticRenderFns } from "./bet-placed-chip.vue?vue&type=template&id=af41a6b8&scoped=true"
import script from "./bet-placed-chip.vue?vue&type=script&lang=js"
export * from "./bet-placed-chip.vue?vue&type=script&lang=js"
import style0 from "./bet-placed-chip.vue?vue&type=style&index=0&id=af41a6b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af41a6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af41a6b8')) {
      api.createRecord('af41a6b8', component.options)
    } else {
      api.reload('af41a6b8', component.options)
    }
    module.hot.accept("./bet-placed-chip.vue?vue&type=template&id=af41a6b8&scoped=true", function () {
      api.rerender('af41a6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-placed-chip.vue"
export default component.exports